;(function( window, document, $, undefined ) {
	'use strict';

	// General Functions

	function general() {

		// Function forEach with callback
		function forEach( list, callback ) {
			for( var n = 0, count = list.length; n < count; n++ ) {
				callback.call( list[n], n );
			}
    }

    function minHeightContent() {
      setTimeout(function(){

        var bodyHeight = $(window).height();
        var utilityBarHeight = $('.utility-bar').height();
        var headerHeight = $('.site-header').height();
        var footerWidgetsHeight = $('.footer-widgets').height();
        var footerHeight = $('.site-footer').height();

        var siteInnerMarginBottom = $('.site-inner').css('marginBottom').replace(/[^-\d\.]/g, '');
        var contentHeight = bodyHeight - ( utilityBarHeight + headerHeight + footerWidgetsHeight + footerHeight );

        if( $('.utility-bar').is(':visible') ) {
          $('.site-inner').css('min-height', contentHeight - parseInt(siteInnerMarginBottom));
        } else {
          $('.site-inner').css('min-height', contentHeight - parseInt(siteInnerMarginBottom) + utilityBarHeight);
        }

      }, 500);
    }

		// Globals
		return {
      forEach: forEach,
      minHeightContent: minHeightContent
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.general = general();

})( window, document, jQuery );
